// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"f55a212f","310":"43202fa1","787":"65af3952","881":"d55358c5","984":"89348f01"}[chunkId] + ".chunk.js";
};